import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import Login from './Pages/Auth/Login';
import ForgotPassword from './Pages/Auth/ForgotPassword';
import Dashboard from './Pages/Dashboard/Dashboard';
import CommissionReport from './Pages/Commissions/CommissionReport';
import PaymentReport from './Pages/Payments/PaymentReport';
import ProfileManage from './Pages/Profile/ProfileManage';
import './Styles/main.css';

function App() {
  const { token } = useSelector(state => state.influencer || {});
  const isAuthenticated = !!token;

  return (

   <Routes>
  <Route 
    path="/login" 
    element={
      !isAuthenticated ? 
        <Login /> : 
        <Navigate to="/" replace />
    } 
  />

  <Route 
    path="/forgot-password" 
    element={
      !isAuthenticated ? 
        <ForgotPassword /> : 
        <Navigate to="/" replace />
    } 
  />

  <Route 
    path="/" 
    element={
      isAuthenticated ? 
        <Dashboard /> : 
        <Navigate to="/login" replace />
    } 
  />

  <Route 
    path="/commissions" 
    element={
      isAuthenticated ? 
        <CommissionReport /> : 
        <Navigate to="/login" replace />
    } 
  />

  <Route 
    path="/payments" 
    element={
      isAuthenticated ? 
        <PaymentReport /> : 
        <Navigate to="/login" replace />
    } 
  />

  <Route 
    path="/profile" 
    element={
      isAuthenticated ? 
        <ProfileManage /> : 
        <Navigate to="/login" replace />
    } 
  />

  <Route 
    path="*" 
    element={
      isAuthenticated ? 
        <Navigate to="/" replace /> : 
        <Navigate to="/login" replace />
    } 
  />
</Routes>


  );
}

export default App;